import React, { useState } from 'react'
import CamposBusqueda from '../../components/listados/CamposBusqueda'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_ARCHIVO_ANALISIS } from '../../../../config/forms'
import { actualizarDatosParaSolicitudAnalisis } from '../../actions/calidad'
import DatosSolicitudAnalisis from '../../components/calidad/DatosSolicitudAnalisis'

function SolicitudAnalisis (props) {
  const [show, setShow] = useState(false)

  const handleSubmit = () => {
    actualizarDatosParaSolicitudAnalisis()
    setShow(true)
  }

  const actualizarFechas = (fechaD, fechaH) => {
    const { change: formChange } = props
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  return (
    <>
      <CamposBusqueda
        actualizarFechas={actualizarFechas}
        handleSubmit={handleSubmit}
        campoTitular
        campoCorredor
        campoCPA
      />
      {show && <DatosSolicitudAnalisis /> }
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaSolicitudAnalisis
}

const withRedux = connect(null, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_ARCHIVO_ANALISIS
})

export default withRedux(withReduxForm(SolicitudAnalisis))
